import { DELIVERY_METHODS_ROUTES } from 'domains/Shipping/DeliveryMethods/shippingRoutes';

export const NATIVE_SHIPPING_METHODS_EDIT_LINKS = {
  'oca-partner-ar': DELIVERY_METHODS_ROUTES.ocaEditSelector,
  correios: DELIVERY_METHODS_ROUTES.correios,
};
